module.exports = __webpack_public_path__ + "img/st.12444111.svg";